import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

import FilterButtonMobile from 'components/atoms/FilterButtonMobile'
import FilterModal from 'components/atoms/FilterModal'
import ComboBox from 'components/molecules/ComboBox'

import './SearchFilters.scss'
function SearchFilters({ onSubmit, className, filters, sort, selectAllText }) {
  const history = useHistory()
  const query = new URLSearchParams(history.location.search)

  function handleChangeFilter(values) {
    if (values.length > 0) {
      setQueries(values)
      if (onSubmit) onSubmit()
    }
  }

  function handleChangeOrder(option) {
    option.value ? query.set('sort_by', option.value) : query.delete('sort_by')
    query.set('sort_order', option.sortOrder)
    sort.handleChange(option)
    pushNewUrl()
  }

  function setQueries(values) {
    if (values.length > 0) {
      const fieldsName = getFields(values)
      fieldsName?.forEach((field) => query.delete(`${field}[]`))
      values?.forEach(({ value, field }) => value && query.append(`${field}[]`, value))
      pushNewUrl()
    } else {
      const newQuery = new URLSearchParams()
      newQuery.set('q', query.get('q'))
      history.push({ search: newQuery.toString() })
    }
  }

  // Get fields names from list of values removing duplicates
  function getFields(values) {
    return values?.map(({ field }) => field).filter((value, index, self) => self.indexOf(value) === index)
  }

  function pushNewUrl() {
    query.set('page', '1')
    history.push({ search: query.toString() })
  }

  return (
    <Container className={`search-filters ${className}`}>
      <Row className="d-none d-md-flex">
        <Col md={7} className="d-flex">
          <div className="filters-desktop d-md-flex align-items-center">
            <p>Filtre resultados por: </p>
            {filters?.map(({ items, field, text, selectAllText }) => (
              <FilterModal
                key={field + text}
                items={items}
                field={field}
                text={text}
                selectAllText={selectAllText}
                onSubmit={handleChangeFilter}
              />
            ))}
          </div>
        </Col>
        <Col md={5} className="d-flex justify-content-end align-items-center">
          <ComboBox
            type="link"
            label="Ordenar resultados por: "
            options={sort?.options}
            selected={sort?.selected}
            onChange={handleChangeOrder}
          />
        </Col>
      </Row>
      <Row className="d-flex d-md-none">
        <Col>
          <div className="mobile-filters">
            <div className="mobile-filters__item">
              <FilterButtonMobile
                text="Filtrar"
                items={filters?.map(({ items, field, text }) => ({ items, field, name: text }))}
                onSubmit={handleChangeFilter}
              />
            </div>

            <div className="mobile-filters__item">
              <ComboBox type="link" options={sort?.options} selected={sort?.selected} onChange={handleChangeOrder} />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

SearchFilters.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.any,
  sort: PropTypes.shape({
    options: PropTypes.array,
    selected: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    }),
    handleChange: PropTypes.func,
  }),
}

export default SearchFilters
